import React from "react";
import { render } from "react-dom";
import Heart from "../widgets/heart";

// Heart
let heartElem = document.querySelectorAll(".widget-heart");
if (heartElem.length) {
    heartElem.forEach(elem => {
        render(<Heart elem={elem} />, elem);
    });
}
